import { fetch } from '../utils/fetch';

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsSize(sizeId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-size/${sizeId}`,
    method: 'get',
  });
}

export function _queryGoodsSizes(
  {
    page, size, direction, sort, goodsId
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-size`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      goodsId
    },
  });
}

/**
 * 新增
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsSize(
  {
    goodsId,
    type,
    coverPath,
    sizeTipId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-size`,
    method: 'post',
    data: {
      goodsId,
      type,
      coverPath,
      sizeTipId,
    },
  });
}

/**
 * 更新
 * @param goodsCategoryId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsSize(sizeId, {
  goodsId,
  type,
  inspirationImg,
  inspirationVideo,
  videoCover,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-size/${sizeId}`,
    method: 'patch',
    data: {
      goodsId,
      type,
      inspirationImg,
      inspirationVideo,
      videoCover,
    },
  });
}

/**
 * 删除
 * @param goodsCategoryId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsSize(sizeId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-size/${sizeId}`,
    method: 'delete',
  });
}
export default {};
